import React from "react";
import { latestEventTitle, teamDisplayName, teamRowSubline } from "../hooks/useCascadeFields";

const MAX_TEAMS = 100;

export const teamRowKey = (t) => `${t?.id}|${t?.leagueKey || t?.leagueName || ""}`;

// "121 teams in Division I, Power 4".
export const teamCountLabel = (count, scopeName) =>
  `${count} ${count === 1 ? "team" : "teams"}${scopeName ? ` in ${scopeName}` : ""}${count > MAX_TEAMS ? ` · showing the first ${MAX_TEAMS}, type to narrow` : ""}`;

// Option padding: 12 x 8 in the rail and the modal, 14 x 10 on phones
// (Selection filters step 3, 2420:2447).
const OPTION_PAD = { md: "px-3 py-2", lg: "px-[14px] py-[10px]" };

// Team options (Figma: the rail's Step 3 list and the modal's typeahead):
// name (by the display rule, its age group, never a year beside it) with
// the alias in tertiary, then the conference or league and the latest
// season below ("Nike EYBL (Boys) 16U · Latest season 2025-26").
// `size="lg"` is the phone list.
const TeamList = ({ teams, selectedTeam, onSelect, className = "", size = "md" }) => (
  <ul role="listbox" aria-label="Teams" className={`overflow-y-auto rounded-[12px] border border-bm-border bg-white ${className}`}>
    {teams.slice(0, MAX_TEAMS).map((t) => {
      const selected = !!selectedTeam && teamRowKey(selectedTeam) === teamRowKey(t);
      const sub = teamRowSubline(t);
      return (
        <li key={teamRowKey(t)} role="option" aria-selected={selected} className="border-b border-bm-mutedbg last:border-b-0">
          <button
            type="button"
            onClick={() => onSelect(t)}
            title={latestEventTitle(t)}
            className={`flex w-full flex-col gap-1 ${OPTION_PAD[size] || OPTION_PAD.md} text-left ${selected ? "bg-bm-orange/[0.08]" : "hover:bg-bm-subtle"}`}
          >
            <span className="bm-label-l text-bm-ink">
              {teamDisplayName(t)}
              {t.source !== "cache_teams" && t.alias && <span className="font-normal text-bm-tertiary"> ({t.alias})</span>}
            </span>
            {sub && <span className="bm-body-s text-bm-tertiary">{sub}</span>}
          </button>
        </li>
      );
    })}
  </ul>
);

export default TeamList;
